module.exports = __webpack_public_path__ + "static/media/Ziplyne Video.8e2be158.webm";